import { Instance } from 'mobx-state-tree';
import { CreatedCustomerWithOrderDtoModelBase } from './CreatedCustomerWithOrderDtoModel.base';

/* The TypeScript type of an instance of CreatedCustomerWithOrderDtoModel */
export interface CreatedCustomerWithOrderDtoModelType extends Instance<typeof CreatedCustomerWithOrderDtoModel.Type> {}

/* A graphql query fragment builders for CreatedCustomerWithOrderDtoModel */
export { selectFromCreatedCustomerWithOrderDto, createdCustomerWithOrderDtoModelPrimitives, CreatedCustomerWithOrderDtoModelSelector } from './CreatedCustomerWithOrderDtoModel.base';

/**
 * CreatedCustomerWithOrderDtoModel
 */
export const CreatedCustomerWithOrderDtoModel = CreatedCustomerWithOrderDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
